var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQoutes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 54,
    viewBox: "0 0 68 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.75 23.75V53.5H0V23.325C0 2.925 19.125 0.375 19.125 0.375L21.675 6.325C21.675 6.325 13.175 7.6 11.475 14.4C9.775 19.5 13.175 23.75 13.175 23.75H29.75ZM68 23.75V53.5H38.25V23.325C38.25 2.925 57.375 0.375 57.375 0.375L59.925 6.325C59.925 6.325 51.425 7.6 49.725 14.4C48.025 19.5 51.425 23.75 51.425 23.75H68Z",
    fill: "#c1006d30"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQoutes);
export default __webpack_public_path__ + "static/media/qoutes.9396d0f46facb7f0c469aa6a312a98dc.svg";
export { ForwardRef as ReactComponent };